import React, { Component } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  FormGroup,
} from "reactstrap";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import axios from "axios";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import {
  NotificationManager,
  NotificationContainer,
} from "../../../components/common/react-notifications";
import { END_POINT } from "../../../constants/defaultValues";
import { injectIntl } from "react-intl";
import IntlMessages from "../../../helpers/IntlMessages";

class AIConfiguration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: null,
      gemini_api_key: "",
      openai_api_key: "",
      bot_persona: props.intl.formatMessage({
        id: "settings.ai.default_persona",
      }),
      knowledge_base: "",
      is_enabled: false,
      provider: "gemini",
      backup_enabled: true,
      isLoading: false,
      isSaving: false,
    };
  }

  componentDidMount() {
    const user_id = localStorage.getItem("user_id");
    if (user_id) {
      this.setState({ user_id }, this.loadConfig);
    }
  }

  loadConfig = async () => {
    try {
      this.setState({ isLoading: true });
      const { user_id } = this.state;
      const res = await axios.get(
        `${END_POINT}/api/ai-config?user_id=${user_id}`,
      );
      if (res.data.success) {
        const {
          gemini_api_key,
          openai_api_key,
          bot_persona,
          knowledge_base,
          is_enabled,
          provider,
          backup_enabled,
        } = res.data.data;

        this.setState({
          gemini_api_key: gemini_api_key || "",
          openai_api_key: openai_api_key || "",
          bot_persona:
            bot_persona ||
            this.props.intl.formatMessage({
              id: "settings.ai.default_persona",
            }),
          knowledge_base: knowledge_base || "",
          is_enabled: !!is_enabled,
          provider: provider || "gemini",
          backup_enabled:
            backup_enabled !== undefined ? !!backup_enabled : true,
          isLoading: false,
        });
      }
    } catch (err) {
      console.error("Load AI Config Error", err);
      this.setState({ isLoading: false });
    }
  };

  handleSave = async () => {
    const { intl } = this.props;
    try {
      this.setState({ isSaving: true });
      const {
        user_id,
        gemini_api_key,
        openai_api_key,
        bot_persona,
        knowledge_base,
        is_enabled,
        provider,
        backup_enabled,
      } = this.state;

      await axios.post(`${END_POINT}/api/ai-config`, {
        user_id,
        gemini_api_key,
        openai_api_key,
        bot_persona,
        knowledge_base,
        is_enabled,
        provider,
        backup_enabled,
      });

      NotificationManager.success(
        intl.formatMessage({ id: "settings.ai.notification.success" }),
        intl.formatMessage({ id: "settings.ai.notification.success-title" }),
        3000,
      );
      this.setState({ isSaving: false });
    } catch (err) {
      console.error("Save AI Config Error", err);
      NotificationManager.error(
        intl.formatMessage({ id: "settings.ai.notification.error" }),
        intl.formatMessage({ id: "settings.ai.notification.error-title" }),
        3000,
      );
      this.setState({ isSaving: false });
    }
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      [name]: type === "checkbox" ? checked : value,
    });
  };

  render() {
    const {
      gemini_api_key,
      openai_api_key,
      bot_persona,
      knowledge_base,
      is_enabled,
      provider,
      backup_enabled,
      isSaving,
      isLoading,
    } = this.state;
    const { intl } = this.props;

    if (isLoading) {
      return <div className="loading" />;
    }

    return (
      <React.Fragment>
        {/* <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="Cấu hình AI Agent" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row> */}
        <Row>
          <Colxx xxs="12">
            <Card className="mb-4">
              <CardBody>
                <h5 className="mb-5">
                  <IntlMessages id="settings.ai.title" />
                </h5>

                <FormGroup>
                  <div className="d-flex align-items-center mb-2">
                    <Switch
                      className="custom-switch custom-switch-primary"
                      checked={is_enabled}
                      onChange={(checked) => {
                        this.setState({ is_enabled: checked });
                      }}
                    />
                    <Label className="mb-0 ml-2">
                      {is_enabled ? (
                        <IntlMessages id="settings.ai.switch.on" />
                      ) : (
                        <IntlMessages id="settings.ai.switch.off" />
                      )}
                    </Label>
                  </div>
                  <small className="text-muted">
                    <IntlMessages id="settings.ai.switch.desc" />
                  </small>
                </FormGroup>

                <FormGroup>
                  <Label>
                    <IntlMessages id="settings.ai.provider.label" />
                  </Label>
                  <Input
                    type="select"
                    name="provider"
                    value={provider}
                    onChange={this.handleChange}
                  >
                    <option value="gemini">
                      {intl.formatMessage({
                        id: "settings.ai.provider.gemini",
                      })}
                    </option>
                    <option value="openai">
                      {intl.formatMessage({
                        id: "settings.ai.provider.openai",
                      })}
                    </option>
                  </Input>
                </FormGroup>

                <FormGroup>
                  <div className="d-flex align-items-center mb-2">
                    <Switch
                      className="custom-switch custom-switch-primary"
                      checked={backup_enabled}
                      onChange={(checked) => {
                        this.setState({ backup_enabled: checked });
                      }}
                    />
                    <Label className="mb-0 ml-2">
                      <IntlMessages id="settings.ai.failover.label" />
                    </Label>
                  </div>
                  <small className="text-muted">
                    <IntlMessages id="settings.ai.failover.desc" />
                  </small>
                </FormGroup>

                <Row>
                  <Colxx md="6">
                    <FormGroup>
                      <Label>
                        <IntlMessages id="settings.ai.gemini.label" />
                      </Label>
                      <Input
                        type="password"
                        name="gemini_api_key"
                        value={gemini_api_key}
                        onChange={this.handleChange}
                        placeholder={intl.formatMessage({
                          id: "settings.ai.gemini.placeholder",
                        })}
                      />
                      <small className="text-muted">
                        <IntlMessages id="settings.ai.gemini.help.text" />{" "}
                        <a
                          href="https://aistudio.google.com/app/apikey"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <IntlMessages id="settings.ai.gemini.help.link" />
                        </a>
                        .
                      </small>
                    </FormGroup>
                  </Colxx>
                  <Colxx md="6">
                    <FormGroup>
                      <Label>
                        <IntlMessages id="settings.ai.openai.label" />
                      </Label>
                      <Input
                        type="password"
                        name="openai_api_key"
                        value={openai_api_key}
                        onChange={this.handleChange}
                        placeholder={intl.formatMessage({
                          id: "settings.ai.openai.placeholder",
                        })}
                      />
                      <small className="text-muted">
                        <IntlMessages id="settings.ai.openai.help.text" />{" "}
                        <a
                          href="https://platform.openai.com/api-keys"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <IntlMessages id="settings.ai.openai.help.link" />
                        </a>
                        .
                      </small>
                    </FormGroup>
                  </Colxx>
                </Row>

                <FormGroup>
                  <Label>
                    <IntlMessages id="settings.ai.persona.label" />
                  </Label>
                  <Input
                    type="textarea"
                    name="bot_persona"
                    value={bot_persona}
                    onChange={this.handleChange}
                    rows="3"
                  />
                  <small className="text-muted">
                    <IntlMessages id="settings.ai.persona.desc" />
                  </small>
                </FormGroup>

                <FormGroup>
                  <Label>
                    <IntlMessages id="settings.ai.knowledge.label" />
                  </Label>
                  <Input
                    type="textarea"
                    name="knowledge_base"
                    value={knowledge_base}
                    onChange={this.handleChange}
                    rows="6"
                    placeholder={intl.formatMessage({
                      id: "settings.ai.knowledge.placeholder",
                    })}
                  />
                  <small className="text-muted">
                    <IntlMessages id="settings.ai.knowledge.desc" />
                  </small>
                </FormGroup>

                <Button
                  color="primary"
                  onClick={this.handleSave}
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <IntlMessages id="settings.ai.saving-btn" />
                  ) : (
                    <IntlMessages id="settings.ai.save-btn" />
                  )}
                </Button>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
        <NotificationContainer />
      </React.Fragment>
    );
  }
}

export default injectIntl(AIConfiguration);
